export type PreviousSearchResults = string[];

function isPreviousSearchResults(data: unknown): data is PreviousSearchResults {
  return Array.isArray(data) && data.every((item) => typeof item === 'string');
}

export function getPreviousSearchResults(): PreviousSearchResults {
  const storedPreviousResults = localStorage.getItem('previousSearchResults');
  if (!storedPreviousResults) {
    return [];
  }

  try {
    const parsedPreviousResults = JSON.parse(storedPreviousResults);
    return isPreviousSearchResults(parsedPreviousResults) ? parsedPreviousResults : [];
  } catch {
    return [];
  }
}
